import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageSelector from './LanguageSelector';
import './Header.css';

const Header: React.FC = () => {
  const { t } = useLanguage();
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <img 
              src="/e6bc9b84-c312-461e-ac75-0ddc311a20bc_200x200.png" 
              alt="Used Car Parts Export" 
              className="logo-image"
            />
            <span className="logo-text">{t('header.logoText')}</span>
          </Link>
          
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li><button onClick={() => scrollToSection('about')} className="nav-link">{t('header.nav.about')}</button></li>
              <li><button onClick={() => scrollToSection('how-it-works')} className="nav-link">{t('header.nav.howItWorks')}</button></li>
              <li><button onClick={() => scrollToSection('contact')} className="nav-link">{t('header.nav.contact')}</button></li>
            </ul>
          </nav>

          <div className="header-controls">
            <LanguageSelector />
            <button 
              className={`hamburger ${isMenuOpen ? 'hamburger-open' : ''}`}
              onClick={toggleMenu}
              aria-label={t('header.ariaLabels.toggleMenu')}
            >
            <span></span>
            <span></span>
            <span></span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
